import React, { useContext, useMemo } from 'react';
import CompareContext, { CompareContextOverride } from '../RecordObject/RecordCompareContext';
import { getChildRecord, getRecordWithLongestUiSchema } from '../../util/recordCompareRecordObject';
import filterLayoutToVisibleFromRecords from '../../util/recordCompareFilterLayoutToVisibleFromRecords';
import Group from '../Group/RecordCompareGroup';
import DMLayoutGroup from '../DMLayoutGroup/DMLayoutGroup';
export default function ObjectGroup(_ref) {
  var property = _ref.property;
  var _useContext = useContext(CompareContext),
    propertyPrefix = _useContext.propertyPrefix,
    records = _useContext.records,
    mergeRecord = _useContext.mergeRecord;
  var childRecords = useMemo(function () {
    return records.map(function (record) {
      return getChildRecord(record, property);
    });
  }, [records, property]);
  var childMergeRecord = useMemo(function () {
    return getChildRecord(mergeRecord, property);
  }, [mergeRecord, property]);
  var childLayout = useMemo(function () {
    return filterLayoutToVisibleFromRecords(getRecordWithLongestUiSchema(childRecords).uiSchema['dm:layout'], childRecords);
  }, [childRecords]);
  return /*#__PURE__*/React.createElement(Group, {
    property: property
  }, /*#__PURE__*/React.createElement(CompareContextOverride, {
    layout: childLayout,
    propertyPrefix: "".concat(propertyPrefix).concat(property, "."),
    records: childRecords,
    mergeRecord: childMergeRecord
  }, /*#__PURE__*/React.createElement(DMLayoutGroup, null)));
}